/** Layouts */
import ShowLayout from '@/views/chantier/components/planning/components/absence/layouts/ShowLayout';

import Show from '@/views/chantier/components/planning/components/absence/components/absence/Show';
import Document from '@/views/fichier/pages/Fichier';
import names from '@/constants/routes/chantier/absence';
const { show, showDocument } = names;

export default [
  {
    path: '/absence/show/:id',
    component: ShowLayout,
    children: [
      {
        path: '',
        name: show,
        component: Show,
        meta: {
          auth: true,
          permission: 'view absence',
        },
      },

      {
        path: 'document/:documentUuid',
        component: Document,
        name: showDocument,
        meta: {
          auth: true,
          permission: 'view absence',
        },
      },
    ],
  },
];
